import { getPermissionsWithParentScopes } from '@/mixins/getPermissionsWithParentScopes';
import { usePage } from '@inertiajs/vue3';

type RequiredPermissions = string | string[] | null | undefined;

export function hasAllPermissions(requiredPermissions: RequiredPermissions): boolean {
    // Exit early if no permissions are required
    if (!requiredPermissions || (Array.isArray(requiredPermissions) && requiredPermissions.length === 0)) {
        return false;
    }

    const $page = usePage();
    const permissions = (Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions]).filter((n): n is string => Boolean(n));

    // Current permissions of the user
    const assignedPermissions: string[] = $page.props.auth.can;

    // For each required permission the user must hold either the permission
    // itself or one of its broader parent scopes (e.g. `asset.*`).
    return permissions.every((permission) => getPermissionsWithParentScopes(permission).some((scoped) => assignedPermissions.includes(scoped)));
}

export default {
    methods: {
        hasAllPermissions,
    },
};
